// extracted by mini-css-extract-plugin
export default {"breadcrub_container":"index_breadcrub_container__AlpGJ","createdSearch":"index_createdSearch__nzFWw","custom_table":"index_custom_table__McG1H"};